export default __webpack_public_path__ + "static/media/stunimmunity.ee3bde0a.png";